document.addEventListener("DOMContentLoaded", function () {
  // Tab functionality
  const tabs = document.querySelectorAll(".tab-btn");
  const contents = document.querySelectorAll(".tab-content");

  // 🔴 兜底：客戶喺 Shopify 後台開產品儲存（填價／上架／改任何一欄）就會清走
  //    body_html 入面嘅 data-tab（2026-09-18 UK 店用時間戳實證；API 寫入本身安全）。
  //    冇咗 data-tab，四個掣照樣顯示但撳落去一片空白 —— 更衰係頁面一載入
  //    initializeCollapsibles() 就已經用 undefined 呼叫 setActiveTab，
  //    先清晒 active 再配唔到嘢，所以連預設嗰格都唔見。
  //    兜底做法：搵唔到 data-tab 就**按位置**對（第 i 個掣 ↔ 第 i 格內容）。
  //    有 data-tab 時行為完全不變。
  function tabIdOf(btn) {
    if (btn && btn.dataset && btn.dataset.tab) return btn.dataset.tab;
    const i = Array.prototype.indexOf.call(tabs, btn);
    const c = i >= 0 ? contents[i] : null;
    return c && c.id ? c.id : null;
  }

  function tabBtnFor(tabId) {
    if (!tabId) return null;
    const byData = document.querySelector(`.tab-btn[data-tab="${tabId}"]`);
    if (byData) return byData;
    for (let i = 0; i < contents.length; i++) {
      if (contents[i].id === tabId) return tabs[i] || null;
    }
    return null;
  }

  function setActiveTab(tabId) {
    const activeTab = tabBtnFor(tabId);
    const activeContent = tabId ? document.getElementById(tabId) : null;
    // 配唔到就乜都唔改 —— 唔好好似舊版咁清晒 active 之後留低一片空白。
    if (!activeTab || !activeContent) return;
    tabs.forEach((t) => t.classList.remove("active"));
    contents.forEach((c) => c.classList.remove("active"));
    activeTab.classList.add("active");
    activeContent.classList.add("active");
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      setActiveTab(tabIdOf(tab));
    });
  });

  // Collapsible functionality (mobile)
  function toggleCollapsible(collapsible) {
    const content = collapsible.nextElementSibling;
    collapsible.classList.toggle("active");
    content.classList.toggle("active");
  }

  document.querySelectorAll(".template-product .collapsible").forEach((coll) => {
    coll.addEventListener("click", () => toggleCollapsible(coll));
  });

  function initializeCollapsibles() {
    if (window.innerWidth <= 727) {
      // Ensure all collapsibles are ready for mobile
      document.querySelectorAll(".template-product .collapsible").forEach((coll) => {
        coll.style.cursor = "pointer";
      });
      // 預設展開第一個摺疊欄（產品介紹／Description），其餘保持收合。
      // 註：手機 .collapsible 冇 data-tab，故直接取第一個（排序上即 Description）。
      const firstCollapsible = document.querySelector(".template-product .collapsible");
      if (firstCollapsible && !firstCollapsible.classList.contains("active")) {
        toggleCollapsible(firstCollapsible);
      }
    } else {
      // Reset all collapsibles in desktop view
      document.querySelectorAll(".template-product .collapsible, .template-product .tab-content").forEach((el) => {
        el.classList.remove("active");
      });
      // Set the default active tab based on the HTML structure
      const defaultActiveTab =
        document.querySelector(".tab-btn.active") || tabs[0] || null;
      if (defaultActiveTab) {
        setActiveTab(tabIdOf(defaultActiveTab));
      }
    }
  }

  // Run on load
  initializeCollapsibles();

  // Run when resizing the window
  window.addEventListener("resize", initializeCollapsibles);

  // FAQ functionality
  document.querySelectorAll(".faq-question").forEach((question) => {
    question.addEventListener("click", () => {
      const answer = question.nextElementSibling;
      answer.classList.toggle("active");
    });
  });

  // Add structured data
  function addStructuredData() {
    const productJson = document.getElementById("ProductJson-{{ section.id }}");
    if (!productJson) return;

    const product = JSON.parse(productJson.textContent);
    const productVariant = product.selected_or_first_available_variant;
    const structuredData = {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: product.title,
      image: [
        product.featured_image
          ? `${window.location.origin}${product.featured_image}`
          : "",
      ],
      description: product.description,
      sku: productVariant.sku,
      mpn: productVariant.barcode,
      brand: {
        "@type": "Brand",
        name: product.vendor,
      },
      offers: {
        "@type": "Offer",
        url: window.location.href,
        priceCurrency: window.shop.currency,
        price: productVariant.price / 100,
        availability: productVariant.available
          ? "https://schema.org/InStock"
          : "https://schema.org/OutOfStock",
        priceValidUntil: new Date(
          new Date().setFullYear(new Date().getFullYear() + 1)
        )
          .toISOString()
          .split("T")[0],
      },
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);
  }

  // Call the function to add structured data
  addStructuredData();
});